import { AddressDTO, CustomerForEditionDTO, Res, SalesOrderType, CustomerDocumentIdType, StartTakeOutOrderParamsDTO, TicketType } from 'core/api';
import { Result } from 'core/infrastructure';
import { deepEquals } from 'core/utils';

export type Data = {
	deliveryDate: Date,
	deliveryTime: Date,
	orderType: SalesOrderType,
	currentAddress: AddressDTO,
	deliveryAddresses: AddressDTO[],
	customer: CustomerForEditionDTO
}

export function emptyData(): Data {

	const now = new Date();
	now.setMilliseconds(0);

	return {
		deliveryDate: now,
		deliveryTime: now,
		orderType: SalesOrderType.Delivery,
		currentAddress: { City: '', Region: '', Street: '', ZipCode: '' },
		deliveryAddresses: [],
		customer: {
			AccountCode: '',
			Address: { City: '', Region: '', Street: '', ZipCode: '' },
			ApplySurcharge: false,
			BusinessName: '',
			CardNumber: '',
			RequireIdentificationCard: false,
			CountryCode: '',
			ExistingCountryCodes: [],
			ExistingDocumentIdTypes: [],
			DocumentIdType: CustomerDocumentIdType.CIF,
			Cif: '',
			ContactPerson: '',
			DeliveryAddresses: [],
			DiscountPercentage: 0,
			Email: '',
			ExistingOffers: [],
			ExistingPosGroups: [],
			ExistingPriceLists: [],
			ExistingTypes: [],
			FiscalName: '',
			Id: 0,
			Notes: '',
			Offers: [],
			PriceList: { Id: 0, GroupsSummary: '', Name: '', TicketType: TicketType.VatIncluded, WorkplacesSummary: '' },
			SendMailing: false,
			ShowNotes: false,
			Telephone: '',
			Type: { Id: 0, Name: '' },
			ValidForAllPosGroups: false,
			ValidPosGroups: [],
			SpecialPrices: [],
			ParentCustomer: {
				ParentCustomerId: 0,
				ParentCustomer: '',
				AccountCode: '',
				Address: { City: '', Region: '', Street: '', ZipCode: '' },
				BusinessName: '',
				Cif: '',
				ContactPerson: '',
				CardNumber: '',
				Email: '',
				FiscalName: '',
				GroupsSummary: '',
				Id: 0,
				SendMailing: false,
				Telephone: '',
				Type: '',
				WorkplacesSummary: '',
				CountryCode: ''
			}
		}
	};
}


export function selectAddress(data: Data, currentAddress: AddressDTO): Data {
	return { ...data, currentAddress };
}

export function setCustomer(data: Data, customer: CustomerForEditionDTO): Data {
	const allAddresses = [customer.Address, ...customer.DeliveryAddresses];
	const currentAddress = allAddresses.find(x => deepEquals(x, data.currentAddress)) || customer.Address;
	return { ...data, deliveryAddresses: allAddresses, currentAddress: currentAddress, customer };
}

export function validate(data: Data): Result<void, string> {

	const errors = [];
	if (data.customer && data.customer.Id === 0)
		errors.push(Res.Msg.MSG_MUST_SEARCH_CUSTOMER_BY_PHONE());

	if (data.currentAddress?.Street === '' && data.orderType === SalesOrderType.Delivery)
		errors.push(Res.Msg.MSG_MUST_INCLUDE_DELIVERY_ADDRESS());

	return errors.length ? Result.error(errors.join('\n')) : Result.ok();
}

export function getParams(state: Data): StartTakeOutOrderParamsDTO {

	const deliveryDate = new Date(state.deliveryDate.getTime());
	// Añado los segundos, porqque si iniciamos un pedido teléfonico en el mismo minuto que hemos abierto jornada, no funcionaría la búsqueda de los deliveryPersons
	// y el informe Z / superZ, ya que por ejemplo las 14:20.00 es menor que 14:20:15 (cuando se abrió jornada)
	deliveryDate.setHours(state.deliveryTime.getHours(), state.deliveryTime.getMinutes(), new Date().getSeconds(), 0);

	return {
		Customer: {
			Address: state.customer!.Address,
			ApplySurcharge: state.customer!.ApplySurcharge,
			BusinessName: state.customer!.BusinessName,
			Cif: state.customer!.Cif,
			DiscountRate: state.customer!.DiscountPercentage / 100,
			FiscalName: state.customer!.FiscalName,
			Id: state.customer!.Id,
			CountryCode: state.customer!.CountryCode
		},
		DeliveryAddress: state.currentAddress || { City: '', Region: '', Street: '', ZipCode: '' },
		DeliveryDate: deliveryDate,
		Type: state.orderType
	};
}

